webpackJsonp([70144966829960],{

/***/ 63:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"banner":"src-components-Banner----banner-module---banner---31KmZ src-styles----utils---shadowLvl1---1bhdJ"};

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bannerModule = __webpack_require__(63);
	
	var _bannerModule2 = _interopRequireDefault(_bannerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Banner = function (_React$Component) {
	  _inherits(Banner, _React$Component);
	
	  function Banner() {
	    _classCallCheck(this, Banner);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Banner.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: _bannerModule2.default.banner },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        this.props.children
	      )
	    );
	  };
	
	  return Banner;
	}(_react2.default.Component);
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(39);
	
	__webpack_require__(40);
	
	var _Banner = __webpack_require__(56);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Button = __webpack_require__(23);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Content = __webpack_require__(57);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Client = __webpack_require__(27);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Form = __webpack_require__(29);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _HalfHero = __webpack_require__(30);
	
	var _HalfHero2 = _interopRequireDefault(_HalfHero);
	
	var _Header = __webpack_require__(31);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Hero = __webpack_require__(32);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _IconList = __webpack_require__(33);
	
	var _IconList2 = _interopRequireDefault(_IconList);
	
	var _Testimonial = __webpack_require__(34);
	
	var _Testimonial2 = _interopRequireDefault(_Testimonial);
	
	var _Testimonials = __webpack_require__(35);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import menu from '../scripts/menu.js';
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Banner2.default,
	      null,
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Contact Us"
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-88dfadeaa1e30eea9f00.js